import type { EcommerceItemWithDetails, ECommerceEventData } from '../../../../../types/analytics/ECommerce';
import type { Configuration } from '../../../../../types/Configuration';
import { PaymentOption } from '../../../../../types/CoreShoppingExperience';

const convertToECommerceEvent = (
  requestId: string,
  items: EcommerceItemWithDetails[],
  partnerConfig: Configuration,
): ECommerceEventData => {
  if (items.length === 0) {
    throw new Error('Invalid items number');
  }
  // when both cashItems and pointItems are not empty it means it's a mixed currency offer
  const cashItems = items.filter((item) => item.paymentOptions?.includes(PaymentOption.CASH));
  const pointItems = items.filter((item) => item.paymentOptions?.includes(PaymentOption.POINTS));

  return {
    requestId,
    transactionId: requestId,
    valueCash: cashItems.reduce((acc, iter) => acc + iter.price, 0),
    valuePoints: pointItems.reduce((acc, iter) => acc + (iter?.pointsPrice ?? 0), 0),
    taxCash: cashItems.reduce((acc, iter) => acc + iter.tax, 0),
    feeCash: cashItems.reduce((acc, iter) => acc + iter.fee, 0),
    taxPoints: pointItems.reduce((acc, iter) => acc + (iter?.pointsTax ?? 0), 0),
    feePoints: pointItems.reduce((acc, iter) => acc + (iter?.pointsFee ?? 0), 0),
    taxDisplay: partnerConfig.taxDisplay ?? 'none',
    paymentTypes: items.flatMap((i) => i.paymentOptions),
    purchaseModes: items.map((i) => i.purchaseMode),
    items,
  };
};

export default convertToECommerceEvent;
